import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const DownloadPdfButton = ({ data, title = "Report", highlightColumns = [] }) => {
  const handleDownload = () => {

    if (!data?.length) return alert("No data available to export");
    const doc = new jsPDF({  unit: "pt" });
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFontSize(18);
    doc.text(title, 14, 20);

    const headers = Object.keys(data[0]);
    const rows = data.map(Object.values);

    const highlightMap = Object.fromEntries(
        highlightColumns.map((col) => [col.key, col.styles || {}])
    );

    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: 60,
      tableWidth: "auto",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        cellWidth: "wrap",
        halign: "left",
      },
      headStyles: {
        fillColor: '#0a1d33',
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      didParseCell: (cellData) => {
        const { section, column } = cellData;
        if (section === "body") {
          const colName = headers[column.index];
          const customStyles = highlightMap[colName];
          if (customStyles) {
            Object.assign(cellData.cell.styles, customStyles);
          }
        }
      },
      didDrawPage: (data) => {
        const tableWidth = data.table?.width || 0;
        if (tableWidth > pageWidth - 80) {
          const scale = (pageWidth - 80) / tableWidth;
          doc.internal.scaleFactor = scale;
        }
      },
    });

    doc.save(`${title.replace(/\s+/g, "_").toLowerCase()}.pdf`);
  };


  return (
    <button
      onClick={handleDownload}
      style={{
        padding: "8px 12px",
        borderRadius: "6px",
        border: "none",
        backgroundColor: "#3e6f97",
        color: "white",
        cursor: "pointer",
      }}
    >
      Download PDF
    </button>
  );
};

export default DownloadPdfButton